module.exports = __webpack_public_path__ + "static/13-48b72f2c8a3021272393771a0e3e4077.jpeg";